module.exports = __webpack_public_path__ + "static/media/croppedphone.85ddfcd9.gif";